module.exports = {"id":"dp1_1l3q1","text":"Search, Browse and Filter Information","instructions":"How often do you try new search tools or features to improve results?","multiselect":false,"category":"1.1","questionType":"Scale","random":false,"options":[{"id":"dp1_1l3q1-a1","text":"Very often","score":4},{"id":"dp1_1l3q1-a2","text":"Often","score":3.6},{"id":"dp1_1l3q1-a3","text":"Sometimes","score":3},{"id":"dp1_1l3q1-a4","text":"Rarely","score":2.4},{"id":"dp1_1l3q1-a5","text":"Never","score":2}],"groupTitle":"Digital Profiler Knowledge Matrix"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.1/l3q1.json
// module id = 927
// module chunks = 41